export default __webpack_public_path__ + "static/media/deepanshu.7bdc31dd.jpeg";